export default __webpack_public_path__ + "static/media/referrals.fe08531c.svg";